// @flow
import { connect } from 'react-redux';

import { toggleHUD } from 'actions/hud';
import { toggleMapLayerDrawer } from 'actions/mapLayerDrawer';

import AppContainer from './AppContainer';

const mapStateToProps = ({
  browser,
  appBar: { mobileLocationSearchShown },
  hud: { open: hudOpen, hudTourSeen },
  drawOverlay: { appInDrawMode, drawToolsTourSeen },
  rt: { rtTourSeen },
  mapLayerDrawer: { open: mapLayerDrawerOpen },
  map: { selectedFeature },
  flags: { hasSubscription },
}) => ({
  browser,
  appInDrawMode,
  mobileLocationSearchShown,
  drawToolsTourSeen,
  hudTourSeen,
  hudOpen,
  introTourSeen: localStorage.intro_tour_seen || false,
  rtTourSeen,
  mapLayerDrawerOpen,
  selectedFeature,
  hasSubscription,
});

const mapDispatchToProps = {
  toggleHUD,
  toggleMapLayerDrawer,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AppContainer);



// WEBPACK FOOTER //
// ./components/AppContainer/index.js